import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { ENV_CONFIG } from '@ottobock/shared/domain';

import { useBackendVersionStore } from '../../+state/version/backend-version-api.store';

import { EnvironmentBuildInfoService } from './environment-build-info.service';

@Component({
  selector: 'remote-update-domain-app-environment-build-info',
  templateUrl: './environment-build-info.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./environment-build-info.css']
})
export class EnvironmentBuildInfo implements OnInit {
  private store = inject(useBackendVersionStore);
  private readonly EnvBackendVersionService = inject(EnvironmentBuildInfoService);
  private env = inject(ENV_CONFIG);

  buildInfo = this.env.buildInfo;
  backendVersion = computed(() => this.store.backendVersion().data?.version || '');

  async ngOnInit(): Promise<void> {
    await this.EnvBackendVersionService.getBackendVersion();
  }
}
